module.exports = __webpack_public_path__ + "static/media/whatsappWhite.b33398f5.svg";